
// import React, { useRef, useEffect, useState } from "react";
// import { Box, Grid, IconButton, Typography } from "@mui/material";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import { ArrowLeft, ArrowRight } from "iconsax-react";
// import { useMediaQuery, useTheme } from "@mui/material";

// export default function Caro({ trim }) {
//   const prevRef = useRef(null);
//   const nextRef = useRef(null);
//   const swiperRef = useRef(null);
//   const [activeIndex, setActiveIndex] = useState(0);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

//   useEffect(() => {
//     if (swiperRef.current) {
//       setTimeout(() => {
//         swiperRef.current.params.navigation.prevEl = prevRef.current;
//         swiperRef.current.params.navigation.nextEl = nextRef.current;
//         swiperRef.current.navigation.init();
//         swiperRef.current.navigation.update();
//       });
//     }
//   }, []);

//   return (
//     <Grid
//       container
//       sx={{
//         position: "relative",
//         marginTop: "30px",
//         backgroundColor: "black",
//         width: "100%",
//         height: {
//           xs: "55vh",   // Mobile
//           sm: "65vh",   // Tablet
//           md: "85vh",   // Laptop
//           lg: "95vh",   // Large screen
//         },
//         overflow: "hidden",
//       }}
//     >
//       {/* Left Arrow */}
//       <IconButton
//         ref={prevRef}
//         aria-label="Previous Slide"
//         sx={{
//           position: "absolute",
//           left: 20,
//           top: "50%",
//           transform: "translateY(-50%)",
//           zIndex: 10,
//           color: "#FFF",
//           padding: { xs: "10px", sm: "20px", md: "30px" },
//           backgroundColor: "rgba(0, 0, 0, 0.3)",
//           "&:hover": {
//             backgroundColor: "rgba(0, 0, 0, 0.6)",
//           },
//           display: "flex",
//         }}
//       >
//         <ArrowLeft size={25} />
//       </IconButton>

//       {/* Swiper */}
//      <Swiper
//   loop={true}
//   modules={[Navigation]}
//   slidesPerView={1}
//   onSwiper={(swiper) => (swiperRef.current = swiper)}
//   onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
//   navigation={{
//     prevEl: prevRef.current,
//     nextEl: nextRef.current,
//   }}
//   style={{
//     width: "100%",
//     height: "100%",
//   }}
// >
//   {trim.map((item, index) => (
//     <SwiperSlide key={index}>
//       <Box
//         sx={{
//           width: "100%",
//           height: "100%",
//         }}
//       >
//         {item.cover.includes(".mp4") ? (
//           <Box
//             component="video"
//             src={
//               isMobile && item?.mobileCover
//                 ? item.mobileCover
//                 : item.cover
//             }
//             autoPlay={activeIndex === index}
//             loop
//             muted
//             playsInline
//             preload={activeIndex === index ? "auto" : "none"}
//             sx={{
//               width: "100%",
//               height: "100%",
//               objectFit: isMobile ? "contain" : "cover",
//             }}
//           />
//         ) : (
//           <Box
//             component="img"
//             loading={index === 0 ? "eager" : "lazy"}
//             decoding="async"
//             src={
//               isMobile && item?.mobileCover
//                 ? item.mobileCover
//                 : item.cover
//             }
//             alt="Banner"
//             sx={{
//               width: "100%",
//               height: "100%",
//               objectFit: isMobile ? "contain" : "cover",
//               objectPosition: "center",
//             }}
//           />
//         )}
//       </Box>
//     </SwiperSlide>
//   ))}
// </Swiper>


//       {/* Right Arrow */}
//       <IconButton
//         ref={nextRef}
//         aria-label="Next Slide"
//         sx={{
//           position: "absolute",
//           right: 20,
//           top: "50%",
//           transform: "translateY(-50%)",
//           zIndex: 10,
//           color: "#FFF",
//           padding: { xs: "10px", sm: "20px", md: "30px" },
//           backgroundColor: "rgba(0, 0, 0, 0.3)",
//           "&:hover": {
//             backgroundColor: "rgba(0, 0, 0, 0.6)",
//           },
//           display: "flex",
//         }}
//       >
//         <ArrowRight size={25} />
//       </IconButton>

//       {/* Title Section */}
//       {trim[activeIndex]?.title && (
//         <Box
//           sx={{
//             position: "absolute",
//             bottom: { xs: "5%", md: "10%" },
//             left: "50%",
//             transform: "translateX(-50%)",
//             textAlign: "center",
//             color: "#fff",
//             px: 2,
//             width: "100%",
//             zIndex: 20,
//           }}
//         >
//           <Typography
//             sx={{
//               fontWeight: "bold",
//               fontSize: {
//                 xs: "1.3rem",
//                 sm: "1.8rem",
//                 md: "2.5rem",
//                 lg: "3rem",
//               },
//             }}
//           >
//             {trim[activeIndex].title}
//           </Typography>

//           <Typography
//             sx={{
//               fontSize: { xs: "0.85rem", md: "1rem" },
//               color: "#ddd",
//               mt: 1,
//             }}
//           >
//             {trim[activeIndex].desc1}
//           </Typography>

//           <Typography
//             sx={{
//               fontSize: { xs: "0.8rem", md: "0.95rem" },
//               color: "#ccc",
//               mt: 0.5,
//             }}
//           >
//             {trim[activeIndex].desc2}
//           </Typography>
//         </Box>
//       )}
//     </Grid>
//   );
// }




























import React, { useRef, useEffect, useState } from "react";
import { Box, Grid, IconButton, Button } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { ArrowLeft, ArrowRight } from "iconsax-react";
import { useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function Caro({ trim }) {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  useEffect(() => {
    if (swiperRef.current) {
      setTimeout(() => {
        swiperRef.current.params.navigation.prevEl = prevRef.current;
        swiperRef.current.params.navigation.nextEl = nextRef.current;
        swiperRef.current.navigation.init();
        swiperRef.current.navigation.update();
      });
    }
  }, []);

  return (
    <Grid
      container
      sx={{
        position: "relative",
        marginTop: "30px",
        backgroundColor: "black",
        width: "100%",
        height: {
          xs: "55vh",
          sm: "65vh",
          md: "85vh",
          lg: "95vh",
        },
        overflow: "hidden",
      }}
    >
      {/* Left Arrow */}
   <IconButton
        ref={prevRef}
        aria-label="Previous Slide"
        sx={{
          position: "absolute",
          left: 20,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 10,
          color: "#FFF",
          padding: { xs: "10px", sm: "20px", md: "30px" },
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
          },
          display: "flex",
        }}
      >
        <ArrowLeft size={25} />
      </IconButton>

      {/* Swiper */}
      <Swiper
        loop={true}
        modules={[Navigation]}
        slidesPerView={1}
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        style={{ width: "100%", height: "100%" }}
      >
        {trim.map((item, index) => (
          <SwiperSlide key={index}>
            <Box sx={{ width: "100%", height: "100%", position: "relative" }}>
              {/* Image / Video */}
              {item.cover.includes(".mp4") ? (
                <Box
                  component="video"
                  src={
                    isMobile && item?.mobileCover
                      ? item.mobileCover
                      : item.cover
                  }
                  autoPlay={activeIndex === index}
                  loop
                  muted
                  playsInline
                  preload={index === 0 ? "auto" : "metadata"}
                  fetchpriority={index === 0 ? "high" : "auto"}
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: isMobile ? "contain" : "cover",
                  }}
                />
              ) : (
                <Box
                  component="img"
                  loading={index === 0 ? "eager" : "lazy"}
                  decoding="async"
                  fetchpriority={index === 0 ? "high" : "auto"}
                  src={
                    isMobile && item?.mobileCover
                      ? item.mobileCover
                      : item.cover
                  }
                  alt="Banner"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: isMobile ? "contain" : "cover",
                  }}
                />
              )}

              {/* Center Button */}

              {item?.link && (
                <Box
                  sx={{
                    position: "absolute",
                    bottom: { xs: "1%", md: "1%" },
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 20,
                  }}
                >
                  <Button
                    onClick={() => navigate(item.link)}
                    sx={{
                      px: { xs: 2, md: 2 },
                      py: 0.6,
                      fontSize: { xs: "0.7rem", md: "0.8rem" },
                      color: "#fff",
                      border: "1px solid #fff",
                      textTransform: "uppercase",
                      backgroundColor: "transparent",
                      minWidth: "auto",
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.15)",
                      },
                      transition: "0.3s ease",
                    }}
                  >
                    Know More
                  </Button>
                </Box>
              )}
            </Box>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Right Arrow */}
     <IconButton
        ref={nextRef}
        aria-label="Next Slide"
        sx={{
          position: "absolute",
          right: 20,
          top: "50%",
          transform: "translateY(-50%)",
          zIndex: 10,
          color: "#FFF",
          padding: { xs: "10px", sm: "20px", md: "30px" },
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          "&:hover": {
            backgroundColor: "rgba(0, 0, 0, 0.6)",
          },
          display: "flex",
        }}
      >
        <ArrowRight size={25} />
      </IconButton>
    </Grid>
  );
}




    